import { SchemaService } from "@/shared/services/SchemaService";
import { PlotSchema } from "../models/PlotSchema";
import { PlottingService } from "./PlottingService";


export class PlottingSchemaService extends SchemaService<PlotSchema> {

    static readonly injectableKey = 'PlottingSchemaService';

    get injectableKey() {
        return (this.constructor as typeof PlottingSchemaService).injectableKey;
    }

    public cdnContentPath: string = "plots/plot_schemas";

    public getInternalSchemas(): Array<PlotSchema> {

        const internalRuleSchemas = [
            {
                "type": `${PlottingService.CUSTOM_PLOT_TYPE}`,
                "display_name": "Unknown Plot",
                "description": "Add unknown plot",
                "category": "Custom",
                "is_visible": false,
                "fields": [
                    {
                        "name": "value",
                        "display_name": "Json",
                        "field_type": "json",
                        "required": true,
                        "description": "Json Value"
                    }
                ],
                "examples": [
                    {
                        "type": "json"
                    }
                ]
            },
        ] as Array<PlotSchema>;

        return internalRuleSchemas;

    }

}